import deepmerge from 'deepmerge';

import { AppConfig } from '../app-config';
import developmentConfig from './development';

const productionConfig = deepmerge<AppConfig>(developmentConfig, {
  baseApiPath: 'https://api.bendhealth.com/',
  apmUrl: 'https://apm.bendhealth.com',
  apmEnv: 'production',
  auth0: {
    domain: 'iam.bendhealth.com',
    clientId: '0n1cKaGk10uUXaOHbzfBV3Vh1pSzwMiL',
    audience: 'https://iam.bendhealth.com',
  },
  keycloak: {
    enabled: true,
    authority: 'https://auth.bendhealth.com/realms/production',
    clientId: 'member-portal',
  },
  calendly: {
    onboardingMeetingURL:
      'https://calendly.com/bcm-intake/bend-health-bcm-evaluation-45-min-rr',
  },
  openReplayConfig: {
    enabled: true,
    ingestPoint: 'https://or.bendhealth.com/ingest',
    projectKey: 'UTfjLQvmxfT067INrMXI',
  },
  stripeKey:
    'pk_live_51JjNzpFEZYlgNqDI6BmPyoZ73xLIQ5njulJHbMUPNeXJEiH6WYfqTEK7Jp03j260FedVWqWaBAt0cX0m7T0QJV8j00s2Vl4zYa',
  stripePackages: {
    // C3
    PsychLed: {
      title: 'Coaching, Therapy & Medication',
      subtitle: '',
      offerText: '',
      price: '219.99',
      timeframe: 'per month',
      stripePriceId: 'price_1LG7gKFEZYlgNqDITVwRsYUG',
    },
    // C2
    CoachingAndTherapy: {
      title: 'Coaching + Therapy',
      subtitle: '',
      offerText: '',
      price: '159.99',
      timeframe: 'per month',
      stripePriceId: 'price_1JmOiAFEZYlgNqDIyY86HN6s',
    },
    // C1
    CoachingOnly: {
      title: 'Coaching',
      subtitle: '',
      offerText: '',
      price: '79.99',
      timeframe: 'per month',
      stripePriceId: 'price_1LG7g0FEZYlgNqDIUn8OP3Tw',
    },
  },
  stripePackagesOneOneTwentyThree: {
    // C3
    PsychLed: {
      title: 'Coaching, Therapy & Medication',
      subtitle: '',
      offerText: '',
      price: '549.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKPY3FEZYlgNqDIGh5oLhuw',
    },
    // C2
    CoachingAndTherapy: {
      title: 'Coaching + Therapy',
      subtitle: '',
      offerText: '',
      price: '399.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKPWmFEZYlgNqDIVOP9BJKQ',
    },
    // C1
    CoachingOnly: {
      title: 'Coaching',
      subtitle: '',
      offerText: '',
      price: '199.99',
      timeframe: 'per month',
      stripePriceId: 'price_1MKPVzFEZYlgNqDI3kTSFPcT',
    },
  },
  tokenOfTrust: {
    domain: 'app.tokenoftrust.com',
    publicKey: 'public_live_2ydLTKgCf6gWLwu8wX6S',
  },
  ziggeoApiKey: '193891312920cbe5161a7c762a8bd520',
  googleMeasurementId: 'G-V7ZF35X04S',
  streamChatAppId: '4662b8p43bx2',
  streamChatDisable: false,
  launchDarklyKey: '6270048f52e5c715abd12d77',
  launchDarklyDisable: false,
  pasteTeaseId: 'jRTStaNAlzFOvJO3pPbiFaxDLfUgMz1xWSpL0kAP',
});

export default productionConfig;
